import React, { useContext, useState } from "react";
import styled from "styled-components";
import { UserContext } from "../contexts/UserContext";
import DropdownList from "./Dropdown/DropdownList";

interface ITitleBar {
  title: string;
  userName?: string;
  userImageUrl?: string;
}
const TitleBar = ({ title, userName, userImageUrl }: ITitleBar) => {
  const { setUser } = useContext(UserContext);
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
  return (
    <SContainer>
      <SHeader>{title}</SHeader>
      <SUserContainer>
        <SLabel>{userName}</SLabel>
        {userImageUrl && (
          <SImg
            onClick={() => {
              setDropdownIsOpen(!dropdownIsOpen);
            }}
            src={userImageUrl}
          />
        )}
        <DropdownList
          setDropdownIsOpen={setDropdownIsOpen}
          dropdownIsOpen={dropdownIsOpen}
          choices={[{ label: "Sign Out", icon: undefined }]}
          dropdownSelected={""}
          onclick={() => {
            setUser(undefined);
          }}
          css={{ margin: "100px 0px 0px 50px", width: "150px" }}
        />
      </SUserContainer>
    </SContainer>
  );
};
export default TitleBar;
const SContainer = styled.div`
  border-bottom: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  padding: 16px 40px;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: saturate(180%) blur(10px);
  -webkit-backdrop-filter: saturate(180%) blur(10px);
  position: sticky;
  top: 0;
  z-index: 10;
`;
const SUserContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  position: relative;
`;
const SHeader = styled.div`
  font-family: "Poppins", "Inter", sans-serif;
  font-weight: 700;
  color: var(--color-primary);
  font-size: 22px;
  letter-spacing: -0.01em;
`;
const SLabel = styled.div`
  font-weight: 500;
  color: var(--color-text);
  font-size: 14px;
`;
const SImg = styled.img`
  cursor: pointer;
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid var(--color-border);
  transition:
    border-color var(--transition),
    transform var(--transition),
    box-shadow var(--transition);
  &:hover {
    border-color: var(--color-primary);
    box-shadow: 0 0 0 3px var(--color-primary-ring);
    transform: scale(1.03);
  }
`;
